<template>
  <v-text-box class="box">
    <template #box-title>αξιζει να κανετε</template>
    <template #box-text>
      <ul class="list">
        <li>
          {{ text.li1 }}
        </li>
        <li>{{ text.li2 }}</li>
        <li>{{ text.li3 }}</li>
      </ul>
    </template>
  </v-text-box>
</template>

<script>
import VTextBox from '@/components/modules/VTextBox.vue';

export default {
  name: 'AgiosDoTextBox',
  components: {
    VTextBox,
  },
  data() {
    return {
      text: {
        li1:
          'Να κάνετε μια ρομαντική βόλτα στα καλντερίμια του με τα παραδοσιακά σπίτια του 19ου αιώνα, που αποτελούν χαρακτηριστικά δείγματα λαϊκής αρχιτεκτονικής.',
        li2:
          'Να αφεθείτε στη μαγεία του γλεντιού που επικρατεί στη πλατεία του Αγ. Νικολάου κατά το τριήμερο πολιτιστικών εκδηλώσεων της Αγ. Παρασκευής, με τη κορύφωσή τους, στις 26 Ιουλίου.',
        li3:
          'Να παραβρεθείτε στα καζάνια για την απόσταξη του τσίπουρου, που ξεκινά κάθε φθινόπωρο.',
      },
    };
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 45%;
}
.list {
  list-style: unset;
}

@media (max-width: 900px) {
  .box {
    width: 100%;
  }
}
</style>
